/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Tooltip, Modal, Loader } from '../../../../UiKit';
import { highAddressIcon, upArrowIconGreen } from '../../../../images/images';
import Shimmer from 'sushiweb/Shimmer';
import { userModel } from '../../../../api';
import { PreviousAddresses } from '../../../popups/PreviousAddresses';
import { getFullDate } from '../../../commons/CommonMethods';
import { ChevronRight } from 'sushiweb/Icons';
import green from 'sushiweb/tokens/color/green';
import { Copy, Eye, EyeOff, SquareArrowOutUpRight } from 'lucide-react';
import InfoToggle from '../../../ComponentsV1/InfoToggle';
import { MetricsForJumboEvent } from '../../../../analytics/constants';
import {
  RecentlyUsedAddressesClickEvent,
  UnmaskAddressClickEvent,
  ViewOnMapClickEvent,
  LatLongCopyEvent,
  OpenGoogleMapsClickEvent,
} from '../../../../analytics/address-view/events';

const AddressDetails = React.memo(function AddressDetails({ orderId }) {
  const [newAddressDetails, setNewAddressDetails] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    const getUserAddressesDetails = () => {
      const queryParams = {};
      queryParams['order_id'] = orderId;
      userModel
        .userUpadtedAddressDetails(queryParams)
        .then((response) => {
          if (!response || (response && response.isError === true))
            return setError(response);

          setNewAddressDetails(response);
        })
        .catch((error) => {
          toast.error(error);
        });
    };

    getUserAddressesDetails();
  }, [orderId]);

  if (!newAddressDetails) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className='tw-flex tw-items-center tw-justify-center tw-h-full'>
        <p className='tw-text-red-700'>{error?.message}</p>
      </div>
    );
  }

  return (
    <div className='tw-flex-col'>
      {newAddressDetails?.map((address) => {
        return (
          <div
            className='tw-flex tw-bg-grey-100 tw-p-5 tw-rounded-lg tw-justify-between tw-items-center tw-mb-1'
            key={''}
          >
            <div className='tw-flex-col tw-mb-1 tw-gap-1'>
              <div
                className='tw-text-grey-900 tw-text-200 tw-font-semibold tw-mb-1'
                data-dd-privacy='mask'
              >
                {address?.address}
              </div>
              {address?.updated_at && (
                <div className='tw-text-grey-700 tw-font-regular tw-text-200'>
                  <span className='tw-font-medium tw-text-200'>
                    Updated At :
                  </span>{' '}
                  {getFullDate(address?.updated_at)}
                </div>
              )}
              {address?.latitude && address?.longitude && (
                <button
                  type='button'
                  className='tw-flex tw-gap-2 tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer'
                  onClick={() =>
                    window.open(
                      `http://maps.google.com/?q=${address?.latitude},${address?.longitude}`,
                      '_blank',
                      'noopener,noreferrer',
                    )
                  }
                  data-dd-privacy='mask'
                >
                  <span className='tw-text-grey-700 tw-font-regular tw-text-200'>
                    <span className='tw-font-medium tw-text-200'>
                      Latitude :
                    </span>{' '}
                    {address?.latitude}
                  </span>
                  <span className='tw-text-grey-700 tw-font-regular tw-text-200'>
                    <span className='tw-font-medium tw-text-200'>
                      Longitude :
                    </span>{' '}
                    {address?.longitude}
                  </span>
                  <span className='icon tw-w-5 tw-h-5 '>
                    <img src={upArrowIconGreen} alt='' />
                  </span>
                </button>
              )}
            </div>
            <div
              className={`tw-flex ${
                address?.updated
                  ? ' tw-bg-green-700 tw-text-base-white '
                  : 'tw-bg-grey-200 tw-text-grey-700'
              } tw-h-fit tw-py-1 tw-px-2 tw-rounded-md tw-text-100 tw-font-semibold`}
            >
              {address?.updated ? 'Updated' : 'Old Address'}
            </div>
          </div>
        );
      })}
    </div>
  );
});

export default function AddressV1(props) {
  const [{ address, view_on_map, id }, setUser] = useState({});

  useEffect(() => {
    const getUserData = () => {
      let queryStrings = {};
      queryStrings['order_id'] = props.orderId;
      userModel.getUserData(queryStrings).then((response) => {
        if (!response || response?.isError) return null;
        setUser(response);
      });
    };

    getUserData();
  }, [props.orderId, props.userId]);

  return (
    <div className='tw-w-full'>
      {!(address && props.order) ? (
        <Shimmer height='100%' width='100%' />
      ) : (
        <AddressComp
          {...props}
          address={address}
          viewOnMap={view_on_map}
          userId={id}
        />
      )}
    </div>
  );
}
class AddressComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userAddress: '',
      showPreviousAddressPopUp: false,
      showUpdatedAddressPopUp: false,
      showCxAddressPopUp: false,
      showServiceableMerchantsPopUp: false,
      loading: false,
      isErrorLoadingAddress: false,
      errorMessage: '',
    };
  }

  openGoogleMap = () => {
    const { mapInfo } = this.props;
    let str_map_url = '';
    if (mapInfo) {
      const { trace_coordinates } = mapInfo;
      const keys = Object.keys(trace_coordinates);
      if (keys && keys.length === 2) {
        const { from, to } = trace_coordinates;
        let from_latitude = from.latitude,
          from_longitude = from.longitude,
          to_latitude = to.latitude,
          to_longitude = to.longitude;
        str_map_url =
          'https://www.google.com/maps/dir/' +
          from_latitude +
          ',' +
          from_longitude +
          '/' +
          to_latitude +
          ',' +
          to_longitude;
        window.open(str_map_url, '_blank');
      } else if (keys && keys.length === 1) {
        let latitude = trace_coordinates[keys[0]].latitude,
          longitude = trace_coordinates[keys[0]].longitude;
        str_map_url =
          'https://www.google.com/maps/place/' + latitude + ',' + longitude;
        window.open(str_map_url, '_blank');
      } else {
        alert('No data available!');
      }
    } else {
      alert('No data available!');
    }
  };

  viewOnMapHandler = () => {
    ViewOnMapClickEvent({
      [MetricsForJumboEvent.order_id]: this.props.orderId,
      [MetricsForJumboEvent.customer_id]: this.props.userId,
      [MetricsForJumboEvent.feature_meta]: {
        has_view_on_map_url: !!this.props.viewOnMap,
      },
    });
    let url = this.props.viewOnMap;
    url
      ? window.open(url, '_blank')
      : toast.error(
          'You dont have access to view on map. please reach out to your POC',
        );
  };

  closeCxAddressModal = () => {
    this.setState({
      showCxAddressPopUp: false,
    });
  };

  renderAddress = (address, latitude, longitude) => {
    if (!address) return null;

    const handleLatLongCopy = () => {
      LatLongCopyEvent({
        [MetricsForJumboEvent.order_id]: this.props.orderId,
        [MetricsForJumboEvent.customer_id]: this.props.userId,
      });
      const latLong = `${latitude}, ${longitude}`;
      navigator.clipboard
        .writeText(latLong)
        .then(() => {
          toast.success('Copied');
        })
        .catch(() => {
          toast.error('Failed to copy');
        });
    };

    return (
      <div className='tw-flex tw-flex-col tw-border tw-border-solid tw-rounded-b-lg tw-border-grey-200 !tw-border-x-0 !tw-border-b-0 tw-bg-white tw-w-full'>
        <span
          className='tw-font-medium tw-text-[1.4rem] tw-text-grey-700 tw-py-3 tw-px-4 tw-overflow-scroll tw-overflow-x-hidden'
          data-dd-privacy='mask'
        >
          {address}
        </span>
        {latitude && longitude && (
          <div className='tw-py-2 tw-px-4 tw-border tw-border-solid tw-border-grey-200 !tw-border-x-0 !tw-border-t-0 tw-flex tw-items-center tw-justify-between tw-gap-2 tw-w-full'>
            <div className='tw-flex tw-gap-2 tw-items-center'>
              <div className='tw-flex tw-gap-2'>
                <div
                  className='tw-text-grey-700 tw-font-regular tw-text-300'
                  data-dd-privacy='mask'
                >
                  <span className='tw-font-medium tw-text-400 tw-mr-1'>
                    Lat :
                  </span>
                  {latitude}
                </div>
                <div
                  className='tw-text-grey-700 tw-font-regular tw-text-300'
                  data-dd-privacy='mask'
                >
                  <span className='tw-font-medium tw-text-400 tw-mr-1'>
                    Lng :
                  </span>
                  {longitude}
                </div>
              </div>
              <Copy
                size={14}
                color='#318616'
                className='tw-cursor-pointer hover:tw-scale-105 tw-transition-all tw-duration-300 tw-ease-in-out'
                onClick={handleLatLongCopy}
              />
            </div>
            <button
              type='button'
              className='tw-flex tw-bg-white tw-items-center tw-justify-center tw-bg-transparent tw-border-none tw-p-0 tw-cursor-pointer hover:tw-scale-105 tw-transition-all tw-duration-300 tw-ease-in-out'
              onClick={() => {
                window.open(
                  `http://maps.google.com/?q=${latitude},${longitude}`,
                  '_blank',
                  'noopener,noreferrer',
                );
                OpenGoogleMapsClickEvent({
                  [MetricsForJumboEvent.order_id]: this.props.orderId,
                  [MetricsForJumboEvent.customer_id]: this.props.userId,
                });
              }}
            >
              <SquareArrowOutUpRight size={14} color='#318616' />
            </button>
          </div>
        )}
      </div>
    );
  };

  unmaskAddress = () => {
    this.setState({
      loading: true,
    });
    const { order } = this.props;
    this.setState({
      isErrorLoadingAddress: false,
      errorMessage: '',
      loading: true,
    });
    let queryStrings = {};
    queryStrings['order_id'] = order.order.order_id;
    userModel.unmaskUserInfo(queryStrings, 'address').then((response) => {
      if (!response || response.isError === true) {
        this.setState({
          isErrorLoadingAddress: true,
          errorMessage: response?.message || 'Something went wrong!',
          loading: false,
        });
        return;
      }

      if (response.status === 'failure') {
        toast.error(
          response.message || 'Something went wrong. please try again later!',
        );
      } else {
        this.setState({
          userAddress: response || '',
          showCxAddressPopUp: true,
        });
      }
      this.setState({
        loading: false,
      });
    });
  };

  previousAddressesHandler = () => {
    RecentlyUsedAddressesClickEvent({
      [MetricsForJumboEvent.order_id]: this.props.orderId,
      [MetricsForJumboEvent.customer_id]: this.props.userId,
      [MetricsForJumboEvent.feature_meta]: {
        is_address_updated: !!this.props.order?.order?.is_address_updated,
      },
    });
    this.setState({
      showPreviousAddressPopUp: true,
    });
  };

  viewAddressDetailsHandler = () => {
    this.setState({
      showUpdatedAddressPopUp: !this.state.showUpdatedAddressPopUp,
    });
  };

  closeModalHandler = () => {
    this.setState({
      showPreviousAddressPopUp: false,
    });
  };

  render() {
    const { isLog, order, setShowAddress, setShowMap, showAddress } =
      this.props;
    const {
      userAddress,
      showCxAddressPopUp,
      isErrorLoadingAddress,
      errorMessage,
    } = this.state;
    const {
      address_confidence,
      address_confidence_icon,
      address_effort,
      address_effort_icon,
    } = order.order ?? {};
    let centerContent = {};
    centerContent = {
      alignItems: isLog ? 'flex-start' : 'center',
      textAlign: isLog ? 'left' : 'center',
    };

    const { address } = userAddress;

    return (
      <div className='tw-w-full' style={centerContent}>
        <div className='tw-flex tw-flex-col tw-w-full tw-border-[1px] tw-border-solid tw-border-x-0 tw-border-t-0 tw-border-b-grey-200'>
          <InfoToggle
            isOpen={showAddress}
            defaultOpen={false}
            openIcon={
              <div
                className='tw-h-14 tw-flex tw-items-center tw-justify-center tw-pr-4 hover:tw-text-base-green hover:tw-scale-105 tw-transition-all tw-duration-200 tw-ease-in-out tw-text-zinc-700'
                data-dd-action-name='Unmask Delivery Address'
                onClick={() => {
                  UnmaskAddressClickEvent({
                    [MetricsForJumboEvent.order_id]: this.props.orderId,
                    [MetricsForJumboEvent.customer_id]: this.props.userId,
                    [MetricsForJumboEvent.feature_meta]: {
                      is_address_updated: !!order?.order?.is_address_updated,
                      address_confidence: address_confidence || '',
                      address_effort: address_effort || '',
                    },
                  });
                  this.unmaskAddress();
                  setShowAddress(true);
                  setShowMap(false);
                }}
              >
                <Eye size={18} />
              </div>
            }
            closeIcon={
              <EyeOff
                size={20}
                className='tw-mr-4 hover:tw-scale-105 tw-transition-all tw-duration-200 tw-ease-in-out tw-text-zinc-700'
              />
            }
            styles={'!tw-w-full'}
            title={
              <div className='tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-4'>
                <div className='addressTitle tw-text-zinc-500 tw-text-[14px] tw-font-medium tw-flex tw-items-center tw-gap-2 tw-leading-none tw-whitespace-nowrap'>
                  <span className='tw-leading-none tw-whitespace-nowrap'>
                    Delivery Address
                  </span>
                  {userAddress?.address_confidence?.length > 0 ? (
                    <Tooltip
                      position='bottom'
                      border={false}
                      title={
                        <p>
                          <span className='icon'>
                            <img
                              src={
                                userAddress.address_confidence_icon ||
                                highAddressIcon
                              }
                              alt=''
                            />
                          </span>
                        </p>
                      }
                      label={userAddress.address_confidence}
                    />
                  ) : null}
                  {address_confidence && address_confidence.length ? (
                    <Tooltip
                      position='bottom'
                      border={false}
                      title={
                        <p>
                          <span className='icon'>
                            <img
                              src={address_confidence_icon || highAddressIcon}
                              alt=''
                            />
                          </span>
                        </p>
                      }
                      label={address_confidence}
                    />
                  ) : null}
                  {address_effort && address_effort.length ? (
                    <Tooltip
                      position='bottom'
                      border={false}
                      title={
                        <p>
                          <span className='icon'>
                            <img
                              src={address_effort_icon || highAddressIcon}
                              alt=''
                            />
                          </span>
                        </p>
                      }
                      label={address_effort}
                    />
                  ) : null}
                  {order?.order?.is_address_updated && (
                    <>
                      <div
                        className={`tw-flex tw-bg-green-100/70 tw-text-base-green tw-border tw-border-solid tw-border-green-300 tw-px-2 tw-py-1 tw-rounded-md tw-text-[1.2rem] tw-whitespace-nowrap tw-font-medium tw-items-center ${
                          order?.order?.has_address_access
                            ? 'tw-cursor-pointer'
                            : ''
                        }`}
                        onClick={
                          order?.order?.has_address_access
                            ? this.viewAddressDetailsHandler
                            : () => {}
                        }
                      >
                        Updated
                        {order?.order?.has_address_access && (
                          <ChevronRight size={13} color={green.z700} />
                        )}
                      </div>
                    </>
                  )}
                </div>
                <SquareArrowOutUpRight
                  size={15}
                  onClick={this.viewOnMapHandler}
                  className='hover:tw-text-base-green hover:tw-scale-105 tw-transition-all tw-duration-200 tw-ease-in-out tw-text-zinc-700'
                  data-dd-action-name='View on Map'
                />
              </div>
            }
            onClose={() => {
              setShowAddress(false);
              setShowMap(false);
            }}
          >
            {/* Error message */}
            {isErrorLoadingAddress && errorMessage ? (
              <span className='tw-font-medium tw-text-[1.4rem] tw-text-red-700 tw-pb-3 tw-px-4 tw-border tw-border-solid tw-border-grey-200 !tw-border-x-0 !tw-border-t-0'>
                {errorMessage}
              </span>
            ) : null}

            {/* Address */}
            {!this.state.loading ? (
              address?.length > 0 && showCxAddressPopUp ? (
                this.renderAddress(
                  userAddress?.address,
                  userAddress?.latitude,
                  userAddress?.longitude,
                )
              ) : null
            ) : (
              <div className='tw-w-full tw-h-32 tw-flex tw-items-center tw-justify-center'>
                <Shimmer height='100%' width='100%' />
              </div>
            )}
          </InfoToggle>
          <div
            className={`tw-text-300 tw-font-medium tw-text-green-700 tw-cursor-pointer tw-leading-none tw-mb-4 tw-px-4 ${
              showCxAddressPopUp ||
              this.state.loading ||
              isErrorLoadingAddress ||
              errorMessage
                ? 'tw-mt-3'
                : ''
            }`}
            onClick={this.previousAddressesHandler}
            data-dd-action-name='View Recently Used Addresses'
          >
            Recently Used Addresses
          </div>
        </div>

        {/* Modals */}
        {this.state.showPreviousAddressPopUp && (
          <Modal
            isVisible
            type='huge'
            title='Recently Used Addresses'
            maxHeight='90vh'
            handleClose={this.closeModalHandler}
            component={<PreviousAddresses userId={this.props.userId} />}
          />
        )}
        {this.state.showUpdatedAddressPopUp && (
          <Modal
            isVisible
            type='medium'
            title={
              <div className='tw-font-extrabold tw-text-500'>
                Address Details
              </div>
            }
            maxHeight='70vh'
            handleClose={this.viewAddressDetailsHandler}
            component={<AddressDetails orderId={this.props.orderId} />}
          />
        )}
      </div>
    );
  }
}
